import { useState } from 'react';
import { ApplicationList } from '../../components/ApplicationList';
import { CombinedFundraisingDetail } from '../../components/CombinedFundraisingDetail';

export const CombinedView = () => {
  const [selectedApplication, setSelectedApplication] = useState(null);

  return !selectedApplication ? (
    <ApplicationList setSelectedApplication={setSelectedApplication} />
  ) : (
    <CombinedFundraisingDetail
      selectedApplication={selectedApplication}
      onBack={() => setSelectedApplication(null)}
    />
  );
};